import React from 'react';
import { useSelector } from 'react-redux';
import { Box, CircularProgress, Grid, Paper } from '@material-ui/core';

import HoSoNote from '../../../containers/GTNS/HoSo/HoSoNote';
import HoSoDetail from '../../../containers/GTNS/HoSo/HoSoDetail';
import { canReviewGtns, canViewGtnsProfile } from '../../../utils/gtnsPermission';

export default function HoSo() {
	const role = useSelector(state => state.userReducer.user?.role);
	const loading = useSelector(state => state.formReducer.loading);

	// TÁCH LÀM 2 QUYỀN:
	//   canScore: chấm điểm & duyệt hồ sơ (quản trị viên).
	//   canView : được mở xem hồ sơ của người khác - GỒM HỘI ĐỒNG BÌNH CHỌN
	//             (vào từ màn Bình chọn khi bấm ảnh ứng viên). Hội đồng xem đầy
	//             đủ, cả cột Điểm/Ghi chú, nhưng CHỈ ĐỌC: HoSoNote tự khoá ô
	//             nhập và ẩn nút duyệt theo role (xem utils/gtnsPermission.js).
	//
	// Bản cũ dùng chung một cờ `isSuperAdmin` và gọi role.includes(...) TRƯỚC
	// khi kiểm tra role tồn tại -> hội đồng không xem được điểm, và crash trắng
	// trang khi role còn undefined.
	const canScore = canReviewGtns(role);
	const canView = canViewGtnsProfile(role);

	if (!role || loading) return <CircularProgress style={{ marginTop: 128 }} />;

	// Admin chấm hồ sơ / hội đồng đọc hồ sơ: bố cục 2 cột — Chi tiết hồ sơ
	// (trái, cuộn) + box Chấm điểm (phải, dính/sticky khi cuộn). Ứng viên: 1 cột.
	if (canView) {
		return (
			<Grid item xs={12}>
				{/* Cột trái (chi tiết) cao -> Grid item phải (stretch mặc định) cũng cao,
				    nhờ đó box chấm điểm position:sticky có khoảng chạy khi cuộn. */}
				<Grid container spacing={3}>
					<Grid item xs={12} lg={9}>
						<Paper className='paper' style={{ marginTop: 32, marginBottom: 16 }}>
							<HoSoDetail isSuperAdmin={canScore} showScoreColumns={canView} />
						</Paper>
					</Grid>
					<Grid item xs={12} lg={3}>
						<Box
							style={{
								position: 'sticky',
								top: 80,
								marginTop: 32,
								maxHeight: 'calc(100vh - 96px)',
								overflowY: 'auto',
							}}
						>
							<HoSoNote />
						</Box>
					</Grid>
				</Grid>
			</Grid>
		);
	}

	return (
    <Grid item xs={12}>
			<Grid container justifyContent='center'>
				<Grid item xs={12} lg={10} xl={8}>
					<Box style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
						<Paper className='paper' style={{ marginTop: 32, marginBottom: 16 }}>
							<HoSoDetail isSuperAdmin={false} />
						</Paper>
					</Box>
				</Grid>
			</Grid>
		</Grid>
	)
}
